import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useFilterBarContext } from './providers/FilterBarProvider';
import { WebFilterBar } from './WebFilterBar';
import { MobileFilterBar } from './MobileFilterBar';

export const FilterBar = () => {
  const theme = useTheme();
  const context = useFilterBarContext();
  
  
  const hasLocationSearch = context.mode === 'search';
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));


  return isSmallScreen ? (
    <MobileFilterBar hasLocationSearch={hasLocationSearch} />
  ) : (
    <WebFilterBar hasLocationSearch={hasLocationSearch} />
  );
};
